import React from 'react';
import { Redirect } from 'react-router-dom';
import Box from '@material-ui/core/Box';

import DashboardLayout from '../_layout/DashboardLayout/dashboard.layout';
import LoadingPage from '../_boilerplate/LoadingPage/loading-page.container';
import { PageTitle } from '../../_core/_ui/typography.component';
import { MyAssignmentsGraphQL } from './my-assignments.graphql';
import { hasCalibrationAssignmentAccess } from '../../../lib/services/scoring.service';
import { HOME_ROUTE, ROLES } from '../../../../_configuration';

export const MyAssignmentsPage: React.FC = () => {
  const { hasAccess, loading } = hasCalibrationAssignmentAccess();

  if (loading) return <LoadingPage />;
  if (!hasAccess) return <Redirect to={HOME_ROUTE} />;

  return (
    <DashboardLayout requiredRoles={[ROLES.SCORING]}>
      <Box mb={2}>
        <PageTitle>Assignments</PageTitle>
      </Box>
      <MyAssignmentsGraphQL />
    </DashboardLayout>
  );
};
